import {
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  StyledAutocomplete,
  StyledAvatar,
  StyledAvatarBox,
  StyledAvatarList,
  StyledBadge,
  StyledChatBox,
  StyledChatHeader,
  StyledContainer,
  StyledConversationFooter,
  StyledDividerBox,
  StyledFileBox,
  StyledGridChat,
  StyledGridMenu,
  StyledList,
  StyledListItem,
  StyledMenu,
  StyledMessageBox,
  StyledMessageTimeBox,
  StyledSearchInput,
  StyledTempFileBox,
  StyledTextField,
  StyledTextMessageBox,
} from "./ChatBox.style";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DoneIcon from "@mui/icons-material/Done";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import { ArrowForwardIos, AttachFile, Close } from "@mui/icons-material";

import MenuIcon from "@mui/icons-material/Menu";
import { theme } from "styles/mui-config";
import { toast } from "react-toastify";
import { DateObject } from "react-multi-date-picker";
import { persian_fa } from "react-date-object/locales/persian_fa";
import ProgressiveBtn from "components/Chat/ProgressiveBtn";
import ChatLoadingCm from "./Loading";
import ChatProgressBarCm from "./UploadProgressBar";

// make color with srting
function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

// make avatar with bgColor and txt
function makeAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[0][1]} `,
  };
}

// message time
const messageTimeSpliter = (time) => {
  const newTime = new DateObject({
    date: time * 1000,
    calendar: persian_fa,
  });

  return `${newTime.hour}:${newTime.minute}`;
};

//////////////////////////////////// main componant  ////////////////////////////////////
export default function ChatBoxCm(props) {
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const [newConversation, setNewConversation] = useState(null);

  // conversation list state
  const [listOpen, setListOpen] = useState(!matches);

  // refs
  const searchRef = useRef();
  const newMessagesRef = useRef();
  const scrollRef = useRef();
  const fileInputRef = useRef();
  const messageInputRef = useRef();

  const [textValue, setTextValue] = useState();
  const [fileValue, setFile] = useState();

  // message option menu stat
  const [open, setOpen] = useState({
    anchorEl: null,
    show: false,
    id: null,
  });

  // submit input
  const onSubmit = () => {
    if (!props?.receiverId) {
      return toast.warn("گفت و گو را انتخاب کنید", {
        autoClose: 3000,
        position: "top-center",
      });
    }
    if (!textValue && !fileValue) return null;

    props.submit({
      reciver_id:
        newConversation ||
        props?.conversations?.find((item) => item.id === props.receiverId)
          .reciver_id,
      text: textValue ?? null,
      file: fileValue ?? null,
    });

    messageInputRef.current.value = null;
    fileInputRef.current.files = null;
    setFile(null);
    setTextValue(null);
  };

  // open menu handler
  const OnClickMessageHandler = (event, id) => {
    setOpen({
      anchorEl: event.currentTarget,
      show: true,
      id: "basic-menu_" + id,
    });
  };

  // close list
  const handleClose = () => {
    setOpen({
      anchorEl: null,
      show: false,
      id: null,
    });
  };

  // copy message text
  const copyMessage = (msg) => {
    navigator.clipboard.writeText(msg);
    setOpen({
      anchorEl: null,
      show: false,
      id: null,
    });
  };

  // delete message
  const deleteMessage = (id) => {
    props.onDeleteMessage(id);
    setOpen({
      anchorEl: null,
      show: false,
      id: null,
    });
  };

  // handle select conversation
  const selectConversation = (id, name) => {
    const res = props?.conversations?.find((item) => item.id == id);
    !res && setNewConversation(id);
    props.onSelectConversation(id, name, res ? false : true);
    searchRef.current.value = "";
  };

  // scroll to down or new messages
  const handleScroll = useCallback(() => {
    if (props.unSeenCount) {
      newMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
    } else {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [props.unSeenCount]);

  const handleSelectedFile = () => {
    const file = fileInputRef.current.files[0];
    setFile(file);
  };

  const openListHandler = useCallback(() => {
    setListOpen(!matches);
  }, [matches]);

  useEffect(() => {
    handleScroll();
    openListHandler();
  }, [handleScroll, openListHandler, props.data, props.receiverId]);

  return (
    <StyledContainer container>
      {props.isUploading ? (
        <ChatProgressBarCm progress={props.uploadProgress} />
      ) : props.isLoading ? (
        <ChatLoadingCm />
      ) : null}

      {/* /////////////////////// chat header /////////////////////// */}
      <StyledChatHeader>
        <StyledAvatarBox>
          {props?.conversations ? (
            <IconButton
              color="secondary"
              sx={{ ml: 2 }}
              onClick={() => setListOpen(!listOpen)}
            >
              {listOpen ? <ArrowForwardIos /> : <MenuIcon />}
            </IconButton>
          ) : null}
          {props.receiverName && (
            <>
              <StyledAvatar {...makeAvatar(props.receiverName)} />
              {props.receiverName}
            </>
          )}
          {props.onRefresh && (
            <IconButton color="secondary" onClick={() => props.onRefresh()}>
              <RestartAltIcon sx={{ margin: "5px" }} />
            </IconButton>
          )}
        </StyledAvatarBox>
        {props?.reciverList && (
          <StyledAutocomplete
            disablePortal
            size="small"
            id="combo-box-demo"
            options={props?.reciverList}
            noOptionsText={"هیچ موردی یافت نشد"}
            onChange={(_, e) => e && selectConversation(e.id, e.label)}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <StyledSearchInput
                fullWidth
                ref={searchRef}
                {...params}
                color="secondary"
                placeholder="جست و جو"
              />
            )}
          />
        )}
      </StyledChatHeader>

      {/* /////////////////////// chat box /////////////////////// */}
      <StyledChatBox container>
        {props?.conversations ? (
          //////////////// chat list //////////////
          <StyledGridMenu item open={listOpen}>
            <StyledList
              sx={{ overflow: "hidden", position: "sticky ", top: 0 }}
            >
              {props?.conversations?.map((items) => {
                return (
                  <StyledListItem
                    key={items.id}
                    sx={{ marginTop: 3 }}
                    disablePadding
                    active={props.receiverName === items.reciver_name ? 1 : 0}
                  >
                    <ListItemButton
                      onClick={() =>
                        selectConversation(items.id, items.reciver_name)
                      }
                    >
                      <ListItemAvatar>
                        {items.unSeenCount > 0 ? (
                          <StyledBadge
                            badgeContent={items.unSeenCount}
                            color="success"
                          >
                            <StyledAvatarList
                              {...makeAvatar(items.reciver_name)}
                            />
                          </StyledBadge>
                        ) : (
                          <StyledAvatarList
                            {...makeAvatar(items.reciver_name)}
                          />
                        )}
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ wordWrap: "unset" }}
                        id={items.id}
                        primary={items.reciver_name}
                      />
                    </ListItemButton>
                  </StyledListItem>
                );
              })}
            </StyledList>
          </StyledGridMenu>
        ) : null}
        {/* ///////////////////// chat messages ///////////////////// */}
        <StyledGridChat item open={listOpen}>
          {props.data ? (
            props.data.map((items, index) => {
              let is_reciver = items.is_reciver;
              return (
                <Fragment key={items.id}>
                  {props.data[index - 1]?.date[0] !== items.date[0] ? (
                    <StyledDividerBox>
                      <Divider
                        sx={{ mb: 3, width: "95%", alignSelf: "center" }}
                      >
                        {items.date[0]}
                      </Divider>
                    </StyledDividerBox>
                  ) : null}
                  {index === props.count - props.unSeenCount ? (
                    <StyledDividerBox ref={newMessagesRef}>
                      <Divider
                        sx={{ my: 4, width: "95%", alignSelf: "center" }}
                      >
                        <Chip color="secondary" label="پیام جدید" />
                      </Divider>
                    </StyledDividerBox>
                  ) : null}
                  <StyledMessageBox $is_reciver={is_reciver}>
                    <StyledTextMessageBox
                      id={"message_box_" + items.id}
                      $is_reciver={is_reciver}
                      onClick={(e) => OnClickMessageHandler(e, items.id)}
                      aria-controls={
                        open ? "basic-menu_" + items.id : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      {/* message with file  */}
                      {items.file ? (
                        <>
                          <StyledFileBox>
                            <ProgressiveBtn
                              is_reciver={items.is_reciver}
                              file={items.file}
                            />
                          </StyledFileBox>
                          {items.text && (
                            <div>
                              <hr
                                style={{
                                  borderColor: is_reciver
                                    ? theme.palette.secondary.main
                                    : theme.palette.primary.main,
                                }}
                              />
                              {items.text}
                            </div>
                          )}
                          <StyledMessageTimeBox>
                            {!is_reciver ? (
                              items.isSeen ? (
                                <DoneAllIcon fontSize="small" />
                              ) : (
                                <DoneIcon fontSize="small" />
                              )
                            ) : null}
                            <div style={{ marginTop: "-3px" }}>
                              {messageTimeSpliter(items.date[1])}
                            </div>
                          </StyledMessageTimeBox>
                        </>
                      ) : (
                        <>
                          <div>{items.text}</div>
                          <StyledMessageTimeBox>
                            {!is_reciver ? (
                              items.isSeen ? (
                                <DoneAllIcon fontSize="small" />
                              ) : (
                                <DoneIcon fontSize="small" />
                              )
                            ) : null}
                            <div style={{ marginTop: "-3px" }}>
                              {messageTimeSpliter(items.date[1])}
                            </div>
                          </StyledMessageTimeBox>
                        </>
                      )}
                    </StyledTextMessageBox>
                  </StyledMessageBox>
                  {/* message options */}
                  <StyledMenu
                    id={"basic-menu_" + items.id}
                    anchorEl={open.anchorEl}
                    open={
                      open.id === "basic-menu_" + items.id ? open.show : false
                    }
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                    sx={{
                      mx: is_reciver ? 1.5 : -1.5,
                      boxShadow: "none",
                      zIndex: 999999,
                    }}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: !is_reciver ? "left" : "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: is_reciver ? "left" : "right",
                    }}
                  >
                    <List sx={{ direction: "ltr" }}>
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => copyMessage(items.text)}>
                          <ListItemIcon>
                            <ContentCopyIcon />
                          </ListItemIcon>
                          <ListItemText primary="کپی متن" />
                        </ListItemButton>
                      </ListItem>
                      {!is_reciver && props.onDeleteMessage && (
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => deleteMessage(items.id)}
                          >
                            <ListItemIcon>
                              <DeleteOutlineIcon fontSize="medium" />
                            </ListItemIcon>
                            <ListItemText primary="حذف پیام" />
                          </ListItemButton>
                        </ListItem>
                      )}
                    </List>
                  </StyledMenu>
                </Fragment>
              );
            })
          ) : (
            <Typography mx={2}>
              {props.receiverName
                ? "پیامی در این گفت و گو ارسال نشده"
                : "گفت و گو را انتخاب کنید"}
            </Typography>
          )}
          <div ref={scrollRef}></div>
        </StyledGridChat>
      </StyledChatBox>
      {
        <StyledGridMenu
          sx={{ overflow: "hidden" }}
          item
          open={listOpen}
        ></StyledGridMenu>
      }
      <StyledConversationFooter item open={listOpen}>
        <Grid container>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <StyledTextField
              open={listOpen}
              placeholder=" پیام "
              variant="outlined"
              color="secondary"
              id="text"
              type={"text"}
              inputRef={messageInputRef}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.keyCode === 13) onSubmit();
              }}
              onInput={(e) => setTextValue(e.target.value)}
              InputProps={{
                endAdornment:
                  fileValue || textValue ? (
                    <>
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setTextValue(false);
                            setFile(false);
                            messageInputRef.current.value = null;
                            fileInputRef.current.files = null;
                          }}
                        >
                          <Close
                            color="primary"
                            sx={{ transform: "rotate(180deg)" }}
                          />
                        </IconButton>
                      </InputAdornment>
                      <InputAdornment position="end">
                        <IconButton onClick={onSubmit}>
                          <SendIcon
                            color="primary"
                            sx={{ transform: "rotate(180deg)" }}
                          />
                        </IconButton>
                      </InputAdornment>
                    </>
                  ) : null,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <IconButton onClick={() => fileInputRef.current.click()}>
                        <AttachFile
                          color="action"
                          sx={{ transform: "rotate(45deg)" }}
                        />
                      </IconButton>
                    </InputAdornment>
                    {fileValue ? (
                      <StyledTempFileBox>
                        <IconButton
                          onClick={() => {
                            setFile(null);
                            fileInputRef.current.files = null;
                          }}
                        >
                          <Close />
                        </IconButton>
                        فایل انتخاب شده
                      </StyledTempFileBox>
                    ) : null}
                  </>
                ),
              }}
            />
            <input
              ref={fileInputRef}
              onChange={handleSelectedFile}
              type={"file"}
              hidden
            />
          </Grid>
        </Grid>
      </StyledConversationFooter>
    </StyledContainer>
  );
}
